// The icon ladder: chips and metadata 16, headers and inline actions 20, dock and
// empty-state glyphs 24. One stroke weight. scripts/lint-tokens.mjs rejects any
// other size on an icon component.
export const iconSize = { chip: 16, header: 20, dock: 24 } as const;
export const iconStroke = 1.75;
